import qs from 'qs';

import axiosInstance from '../protected';

import {getPartyRelationsUrl} from '../api.config';

import {
  IJSONResponseListPartyPartyRelDto,
  IPartyPartyRel,
  IPartyPartyRelPostBody,
} from '../../shared/types/party.types';
import {IPageable} from '../../shared/types/pageable.types';

export const PartyRelationsService = {
  async getAll(pageable: IPageable = {}) {
    return await axiosInstance.get<IJSONResponseListPartyPartyRelDto>(getPartyRelationsUrl(), {
      params: pageable,
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });
  },

  async getById(id: string) {
    const res = await axiosInstance.post<IPartyPartyRel[]>(getPartyRelationsUrl(`/findByIDs`), [id]);
    return {data: res.data[0]};
  },

  async update(data: IPartyPartyRel) {
    return await axiosInstance.put<IPartyPartyRel>(getPartyRelationsUrl(), data);
  },

  async delete(id: number) {
    await axiosInstance.delete(getPartyRelationsUrl(`/`), {
      data: [id],
    });
  },
  async create(data: IPartyPartyRelPostBody) {
    return await axiosInstance.post<IPartyPartyRel>(getPartyRelationsUrl(), data);
  },
};
